export const actionTypes = {
  LOADING_START: "LOADING_START",
  LOADING_STOP: "LOADING_STOP",
  FIELD_STATE_TRUE: "FIELD_STATE_TRUE",
  ADD_DEPARTMENT_SUCCESS: "ADD_DEPARTMENT_SUCCESS",
  ADD_DEPARTMENT_FAIL: "ADD_DEPARTMENT_FAIL",
  EDIT_DEPARTMENT: "EDIT_DEPARTMENT",
  UPDATE_DEPARTMENT_SUCCESS: "UPDATE_DEPARTMENT_SUCCESS",
  SHOW_DEPARTMENT_LIST: "SHOW_DEPARTMENT_LIST",
  CLEAR_FIELDS: "CLEAR_FIELDS",
  DELETE_DEPARTMENT: "DELETE_DEPARTMENT",
  DEPARTMENT_ERROR: "DEPARTMENT_ERROR",
  IS_EDIT_DEP: "IS_EDIT_DEP",
  DEP_BTN_LOADING: "DEP_BTN_LOADING",
  DEP_BTN_DISABLE: "DEP_BTN_DISABLE"
};
